import { DashboardSubMenuRoutes } from '../../../modules/Dashboard/dashboardPagesConfig';
import { Navigate } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

const DashboardWeb = lazyLoad(() =>
  import(/*  webpackChunkName: 'Dashboard', webpackPrefetch: true */ '.'),
);

const OutreachDashboard = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'OutreachDashboard', webpackPrefetch: true */ './Outreach'
  ),
);

const SupportDashboard = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SupportDashboard', webpackPrefetch: true */ './Support'
  ),
);

export const dashboardMenuRoutes = [
  {
    component: SupportDashboard,
    title: 'Dashboard',
    path: DashboardSubMenuRoutes.SUPPORT_DASH,
  },
  {
    component: OutreachDashboard,
    title: 'Outreach',
    path: DashboardSubMenuRoutes.OUTREACH_DASH,
  },
];

// routes declaration
export const dashboardRoutes = [
  {
    component: Navigate,
    path: '/dashboard',

    replace: true,
    to: '/dashboard' + DashboardSubMenuRoutes.DEFAULT,
    // toAdmin: '/dashboard' + DashboardSubMenuRoutes.DEFAULT_ADMIN,
    needsAuth: true,
  },
  {
    component: DashboardWeb,
    title: 'Dashboard',
    path: '/dashboard/*',
    needsAuth: true,
  },
];
